/**
 * PORTED — RO-11-02 / #44587.
 * Origin: `excellent/app/_chrome/top-nav.tsx` (server entry).
 *
 * The Next server half resolved loadRailScope + isCopilotEnabled and handed
 * props to TopNavClient. On the Vite host those fields arrive via
 * `GET /api/shell` → ShellData (RO-11-01). This wrapper is the thin client
 * entry that maps ShellData onto TopNavClient props.
 */

import type { ShellData } from "../shell-data";
import { TopNavClient } from "./top-nav-client";

export function TopNav({ data }: { data: ShellData }) {
  return (
    <TopNavClient
      projects={data.projects}
      allProjects={data.allProjects}
      groups={data.groups}
      workspaceName={data.activeWorkspaceName}
      defaultSlug={data.defaultSlug}
      reviewCount={data.reviewCount}
      enabledSections={data.rail.sections}
      totalSections={data.rail.totalSections}
      copilotEnabled={data.copilot.enabled}
    />
  );
}
